import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLang, copy } from "@/i18n";

export default function CookieBanner() {
  const { lang } = useLang();
  const b = copy[lang].banner;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("fmf_consent")) return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const answer = (value) => {
    localStorage.setItem("fmf_consent", value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-6 inset-x-0 z-50 flex justify-center px-6 pointer-events-none"
        >
          <div
            className="pointer-events-auto max-w-xl w-full border px-8 py-7 text-center backdrop-blur-md"
            style={{
              borderColor: "var(--line-soft)",
              background: "rgba(5, 5, 5, 0.88)",
            }}
          >
            <p className="font-mono-fmf text-sm leading-relaxed text-white">
              {b.text}
            </p>
            <div className="mt-6 flex items-center justify-center gap-8">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => answer("accepted")}
                className="font-mono-fmf text-[13px] uppercase tracking-[0.35em] text-white hover:opacity-60 transition-opacity duration-700"
              >
                {b.accept}
              </button>
              <button
                data-testid="cookie-decline-btn"
                onClick={() => answer("declined")}
                className="font-mono-fmf text-[13px] uppercase tracking-[0.35em] text-[var(--bone-dim)] hover:text-white transition-colors duration-700"
              >
                {b.decline}
              </button>
            </div>
            <Link
              data-testid="cookie-policy-link"
              to="/privacy"
              className="mt-5 inline-block font-mono-fmf text-[11px] uppercase tracking-[0.3em] text-[var(--bone-dim)] hover:text-white transition-colors duration-700"
            >
              {b.more}
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
